const turnosSeleccionadosInitialState = {
    turnosSeleccionados : {
        data: [], 
        loading: false, 
        error: false 
    }
}

export default turnosSeleccionadosInitialState; 